import React from "react";
import {
  Grid,
  Button,
  TextField,
  InputAdornment,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  Search as SearchIcon,
  Close as CloseIcon
} from "@mui/icons-material";
import {
  LoadingContent,
  VisibleContent
} from "../../../../../components";
import {getImage} from "../../../../../utils/image";
import numberFormat from "../../../../../utils/numberFormat";
import rateConvert from "../../../../../utils/rateConvert";
import {useBuyNumber} from "../../../../../contexts/BuyNumberContext";
import getTrans from "../../../../../languages/getTrans";

const CountriesList = ({ items, isLoading }) => {
  const classes = useStyles();

  const [search, setSearch] = React.useState("");
  const handleChangeSearch = (event) => {
    const value = event?.target?.value || "";
    setSearch(value);
  };
  const handleClearSearch = () => {
    setSearch("");
  };
  const filteredItems = React.useMemo(() => {
    if (!search.trim()) {
      return items;
    }
    const searchLower = search.toLowerCase().trim();
    return items.filter(item =>
      item?.name?.toLowerCase().includes(searchLower)
    );
  }, [items, search]);

  if (isLoading) {
    return <LoadingContent/>
  }
  return (
    <div className={classes.root}>
      <div className={classes.head}>
        <div className={classes.headIcon}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.2646 7.89516C15.6069 3.84425 14.0554 1 12.25 1C10.4446 1 8.89314 3.84425 8.23538 7.89516H16.2646ZM7.89516 12.25C7.89516 13.2571 7.9496 14.2233 8.04486 15.1532H16.4506C16.5459 14.2233 16.6003 13.2571 16.6003 12.25C16.6003 11.2429 16.5459 10.2767 16.4506 9.34677H8.04486C7.9496 10.2767 7.89516 11.2429 7.89516 12.25ZM22.6245 7.89516C21.3271 4.81502 18.7006 2.43347 15.4572 1.47177C16.564 3.00504 17.3261 5.31401 17.7253 7.89516H22.6245ZM9.03831 1.47177C5.79939 2.43347 3.16835 4.81502 1.8755 7.89516H6.7747C7.16935 5.31401 7.93145 3.00504 9.03831 1.47177ZM23.1099 9.34677H17.9068C18.002 10.2994 18.0564 11.2747 18.0564 12.25C18.0564 13.2253 18.002 14.2006 17.9068 15.1532H23.1053C23.3548 14.2233 23.4955 13.2571 23.4955 12.25C23.4955 11.2429 23.3548 10.2767 23.1099 9.34677ZM6.44355 12.25C6.44355 11.2747 6.49798 10.2994 6.59325 9.34677H1.39012C1.14516 10.2767 1 11.2429 1 12.25C1 13.2571 1.14516 14.2233 1.39012 15.1532H6.58871C6.49798 14.2006 6.44355 13.2253 6.44355 12.25ZM8.23538 16.6048C8.89314 20.6557 10.4446 23.5 12.25 23.5C14.0554 23.5 15.6069 20.6557 16.2646 16.6048H8.23538ZM15.4617 23.0282C18.7006 22.0665 21.3317 19.685 22.629 16.6048H17.7298C17.3306 19.186 16.5685 21.495 15.4617 23.0282ZM1.8755 16.6048C3.17288 19.685 5.7994 22.0665 9.04284 23.0282C7.93599 21.495 7.17389 19.186 6.7747 16.6048H1.8755Z" fill="#FB7800"/>
          </svg>
        </div>
        <div className={classes.headName}>{getTrans('countriesList.Остальные страны')}</div>
      </div>
      <div className={classes.searchContainer}>
        <SearchInput
          value={search}
          onChange={handleChangeSearch}
          onClear={handleClearSearch}
        />
      </div>
      <Grid container spacing={1}>
        {filteredItems.map((item) => (
          <Grid key={`item-${ item.country_id }`} item xs={12}>
            <CountryCard item={item} />
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
const CountryCard = ({item}) => {
  const classes = useStyles();
  const { handleOpenBuy } = useBuyNumber();
  const [multiPrices] = React.useState(() => {
    return (item.prices || []).sort((a, b) => {
      return b.value - a.value;
    });
  });
  const isMultiPrices = Boolean((item?.prices || []).length > 0);

  const [isShowMore, setShowMore] = React.useState(false);
  const handleChangeShowMore = () => {
    return setShowMore(true)
  }

  const handleBuyNumber = async (multiPrice = null) => {
    handleOpenBuy({
      serviceSlug: item.service_slug,
      serviceExtraId: item.service_external_id,

      countryId: item.country_id,
      countrySlug: item.country_slug,
      countryExtraId: item.country_external_id,

      initPrice: multiPrice?.value
    });
  }

  const countPrint = `${numberFormat(item.count)} ${getTrans('common.шт')}`
  const pricePrint = React.useState(() => {
    const _value = isMultiPrices ? multiPrices?.[0]?.value : item.price;
    return `${rateConvert(_value, {useSybmol: true, decimalCount: 'auto'})}`
  })

  return (
    <div className={classes.countryCard}>
      <Button className={classes.countryCardMain} onClick={handleBuyNumber.bind(this, null)}>
        <div className={classes.countryCardMainIcon}>
          <img src={getImage(item.icon_id, {width: 32, height: 32})}/>
        </div>
        <div className={classes.countryCardMainName}>{item.name}</div>
        <div className={classes.countryCardMainCount}>{countPrint}</div>
        <div className={classes.countryCardMainBuy}>
          {pricePrint}
        </div>
      </Button>
      <VisibleContent visible={isMultiPrices}>
        <div className={classes.countryCardExtra}>
          <Grid container spacing={0.5}>
            {multiPrices.map((multiPrice, index) => {
              if (index > 1 && !isShowMore) return null
              return (
                <Grid item xs={12}>
                  <Button className={classes.countryMultiPrice} onClick={handleBuyNumber.bind(this, multiPrice)}>
                    <div className={classes.countryMultiPriceCount}>
                      {getTrans('countriesList.Доступно')} {multiPrice.quantity} {getTrans('common.шт')}
                    </div>
                    <div className={classes.countryMultiPriceBuy}>
                      {rateConvert(multiPrice.value, {decimalCount: 'auto', useSybmol: true})}
                    </div>
                  </Button>
                </Grid>
              )
            })}
            <VisibleContent visible={multiPrices.length > 2 && !isShowMore}>
              <Grid item xs={12}>
                <Button className={classes.buttonMore} onClick={handleChangeShowMore}>
                  {getTrans('countriesList.Показать все')}
                </Button>
              </Grid>
            </VisibleContent>
          </Grid>
        </div>
      </VisibleContent>
    </div>
  )
}
const SearchInput = ({ value, onChange, onClear }) => {
  const classes = useStyles();

  return (
    <TextField
      fullWidth
      value={value}
      onChange={onChange}
      placeholder={getTrans('countriesList.Поиск по странам')}
      variant="outlined"
      className={classes.searchInput}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" className={classes.searchAdornmentStart}>
            <SearchIcon className={classes.searchIcon} />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position="end" className={classes.searchAdornmentEnd}>
            <CloseIcon
              className={classes.closeIcon}
              onClick={onClear}
            />
          </InputAdornment>
        ),
        className: classes.inputBase,
      }}
    />
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    padding: "10px",
    marginTop: "12px",
    borderRadius: "12px",
    background: '#0F191F',
    boxSizing: "border-box",
    border: "1px solid #FFFFFF1A",
  },

  head: {
    gap: "8px",
    display: "flex",
    marginBottom: "6px",
    alignItems: "center",
  },
  headName: {
    marginTop: "-4px",
    fontSize: 18,
    fontWeight: "500",
    lineHeight: "22px",
    color: theme.palette.text.primary,
  },

  countryCard: {
    width: "100%",
    borderRadius: "12px",
    boxSizing: "border-box",
    flexDirection: "column",
    background: "#24323A!important"
  },
  countryCardMain: {
    width: "100%",
    padding: "4px",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
  },
  countryCardMainIcon: {
    width: 32,
    height: 32,
    display: "flex",
    overflow: "hidden",
    borderRadius: "8px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "50% 50%",
    }
  },
  countryCardMainName: {
    flex: "auto",
    marginLeft: "8px",

    fontSize: 16,
    textAlign: "left",
    fontWeight: "500",
    lineHeight: "20px",
    color: theme.palette.text.primary,

    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  countryCardMainCount: {
    whiteSpace: 'nowrap',
  },
  countryCardMainBuy: {
    height: "32px",
    display: "flex",
    minWidth: "64px",
    padding: "0 6px",
    marginLeft: "8px",
    borderRadius: "8px",
    alignItems: "center",
    background: "#FB7800",
    boxSizing: "border-box",
    justifyContent: "flex-start",

    color: "white",
    fontSize: "13px",
    fontWeight: "500",
    lineHeight: "16px",
  },

  countryCardExtra: {
    padding: "4px",
    boxSizing: "border-box",
    borderTop: "1px solid #43545D",
  },

  countryMultiPrice: {
    width: "100%",
    padding: "2px",
    paddingLeft: "8px",
    borderRadius: "8px",
    alignItems: "center",
    boxSizing: "border-box",
    border: "1px solid #FFFFFF1A",
    justifyContent: "space-between",
    background: "#FFFFFF0D!important",
  },
  countryMultiPriceBuy: {
    height: "32px",
    display: "flex",
    minWidth: "60px",
    padding: "0 6px",
    marginLeft: "8px",
    borderRadius: "8px",
    alignItems: "center",
    background: "#FB7800",
    boxSizing: "border-box",
    justifyContent: "flex-start",

    color: "white",
    fontSize: "13px",
    fontWeight: "500",
    lineHeight: "16px",
  },
  countryMultiPriceCount: {
    fontSize: 14,
    color: "white",
    opacity: "0.5",
    fontWeight: "400",
    lineHeight: "20px"
  },

  buttonMore: {
    width: "100%",
    height: "34px",
    display: "flex",
    borderRadius: "8px",
    alignItems: "center",
    border: "1px solid #FFFFFF1A",
    background: "#FFFFFF0D!important",
  },

  searchContainer: {
    marginTop: "4px",
    marginBottom: "8px",
    padding: "0 0 4px 0",
    boxSizing: "border-box",
  },
  searchInput: {
    "& .MuiOutlinedInput-root": {
      height: "32px",
      borderRadius: "8px",
      background: "#FFFFFF0D",
      border: "1px solid #FFFFFF1A",
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "0 6px",
      fontSize: 13,
      color: theme.palette.text.primary,
      "&::placeholder": {
        opacity: 0.3,
        color: theme.palette.text.primary,
      },
    },
  },
  inputBase: {
    "& input": {
      "&::placeholder": {
        opacity: 0.3,
      },
    },
  },
  searchAdornmentStart: {
    marginRight: "4px",
  },
  searchAdornmentEnd: {
    marginLeft: "4px",
  },
  searchIcon: {
    fontSize: 16,
    color: "rgba(255,255,255,0.3)",
  },
  closeIcon: {
    fontSize: 14,
    color: "rgba(255,255,255,0.3)",
    cursor: "pointer",
  },
}));

export default CountriesList
export {
  CountryCard
}
